const initialState = {
    status: "idle",
    screensFrom: null
};

const PsvReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_PSV_SCREENS_FROM_LOADING":
            return {
                ...state,
                status: "loading"
            };
        case "SET_PSV_SCREENS_FROM":
            return {
                ...state,
                status: "loaded",
                screensFrom: action.payload
            };
        case "SET_PSV_SCREENS_FROM_FAILED":
            return {
                ...state,
                status: "failed",
                screensFrom: null
            };
        case "RESET_STORE":
            return initialState;
        default:
            return state;
    }
};

export default PsvReducer;
